import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { ProgressBarStyles, applyProgressBarCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-progress-bar',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxProgressBarStyleDirective {
  componentStyle = input<{
    style: ProgressBarStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyProgressBarCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
